import React, { useRef, useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import RefreshIcon from '@mui/icons-material/Refresh';
import ConnectionStatus from './ConnectionStatus';

function Header({
  showMenuButton = true,
  onRefreshClick,
  onMenuClick,
  showConnectionStatus = true
}) {
  const [spinning, setSpinning] = useState(false);
  const spinTimeoutRef = useRef(null);

  const handleRefresh = () => {
    setSpinning(true);
    clearTimeout(spinTimeoutRef.current);
    spinTimeoutRef.current = setTimeout(() => setSpinning(false), 600);
    onRefreshClick?.();
  };

  return (
    <AppBar
      position="fixed"
      style={{ backgroundColor: '#3f51b5', zIndex: 1100, paddingTop: 'env(safe-area-inset-top)' }}
    >
      <Toolbar>
        {showMenuButton && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={onMenuClick}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography variant="h6" style={{ flexGrow: 1 }}>
          DriverApp
        </Typography>

        {showConnectionStatus && (
          <ConnectionStatus style={{ marginRight: 16 }} />
        )}

        <style>{`
          @keyframes headerRefreshSpin { to { transform: rotate(360deg); } }
          .header-refresh-icon.spinning { animation: headerRefreshSpin 0.6s ease; }
        `}</style>
        <IconButton color="inherit" aria-label="refresh" onClick={handleRefresh}>
          <RefreshIcon className={spinning ? 'header-refresh-icon spinning' : 'header-refresh-icon'} />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
